<aside class="usermenu col-2" *ngIf="isAdminRoute !== null">
  <div class="cards-user">
    <div *ngIf="currentUser">
      <div class="user-portrait">
        <div class="photo-parent" *ngIf="avatar$ | async as avatar; else defaultPhotoTempl">
          <img [src]="avatar" />
      </div>
      <ng-template #defaultPhotoTempl>
        <div class="photo-parent">
          <img [src]="defaultPhoto" />
      </div>
      </ng-template>
        <div class="detail-position">
          <div class="user-data user-department lh-1-3">
            {{ currentUser.businessUnitDisplayName }}
          </div>
          <div class="user-data mb-0 lh-1-3">
            {{ currentUser.country }}
          </div>
          <div *ngIf="account" class="logout-block">
            <a (click)="logout()" title="Sign out" class="logout_btn"></a>
          </div>
        </div>
      </div>
      <div class="user-name lh-1-3">
        {{ currentUser.isActive ? currentUser.displayName : 'Leaver ' + currentUser.gpid }}
      </div>
      <div class="user-position mb-0 lh-1-3">
        {{ currentUser.position }}
      </div>
    </div>
    <div *ngIf="hasAccessToAdminMenu()" class="version-switch">
      <div class="switch" [class.switch-admin]="isAdminRoute">
        <label>
          <input (click)="toggleUserMenu()" type="checkbox" />
          <span class="lever switch-col-blue"></span>
        </label>
      </div>
      <span [class.display-none]="!isAdminRoute" class="title-version">
        {{ 'lang.userMenu.version.user' | translate }}
      </span>
      <span [class.display-none]="isAdminRoute" class="title-version">
        {{ 'lang.userMenu.version.admin' | translate }}
      </span>
    </div>
  </div>
  <div class="main-navigation" slimScroll height="350px" alwaysVisible="true" size="3px" transition=".1" wheelStep="10">
    <div [collapse]="!isAdminRoute" class="navigation nav-admin">
      <div
        [routerLink]="['admin/question-list']"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="admin-question-list"
      >
        Question Bank
      </div>
      <div
        [routerLink]="['admin/survey-list']"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="admin-servey-list"
      >
        Surveys
      </div>
      <div
        [routerLink]="['admin/processes-list']"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="admin-process-list"
      >
        Processes
      </div>
      <!-- TODO report -->
      <!-- <div [routerLink]="['reports']" routerLinkActive="active-navigation" class="navigation-list" id="admin-reports">Reports</div> -->
      <div
        [routerLink]="['admin/extra']"
        routerLinkActive="active-navigation"
        class="navigation-list additionally"
        id="admin-additionally"
      >
        Additionally
      </div>
    </div>
    <div [collapse]="isAdminRoute" class="navigation nav-user">
      <div
        [routerLink]="['user/my-page', { requirementType: requirementType.ByAppraisee }]"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="user-page-list"
      >
        {{ 'lang.userMenu.myPage' | translate }}
      </div>
      <div
        [routerLink]="['user/survey-list']"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="user-survey-list"
      >
        {{ 'lang.userMenu.mySurveys' | translate }}
      </div>
      <div
        [routerLink]="['user/feedback-chat']"
        routerLinkActive="active-navigation"
        class="navigation-list"
        id="user-feedback-list"
      >
        {{ 'lang.userMenu.myFeedback' | translate }}
      </div>
      <div *ngIf="currentUserTeam$ | async as team">
        <div
          *ngIf="team.length > 0"
          [routerLink]="[
            'user/my-team',
            { requirementType: requirementType.ByPerformanceManager, isMyTeamSurveyTab: isMyTeamSurveyTab }
          ]"
          routerLinkActive="active-navigation"
          [routerLinkActiveOptions]="{ exact: true }"
          class="navigation-list mb-0"
          (click)="isCollapsedMyTeam = !isCollapsedMyTeam"
          id="my-team"
        >
          {{ 'lang.userMenu.myTeam' | translate }}
        </div>
        <div [ngClass]="{ 'hide-menu': isCollapsedMyTeam }">
          <div>
            <div
              *ngFor="let user of sortByName(team)"
              class="my-team"
              (click)="activeTeamMateId = user.id"
              [ngClass]="{ 'active-navigation': activeTeamMateId == user.id }"
              [routerLink]="[
                'user/my-team',
                {
                  requirementType: requirementType.ByPerformanceManager,
                  teammatePersonId: user.personId,
                  teammateEmployeeId: user.id,
                  isMyTeamSurveyTab: isMyTeamSurveyTab
                }
              ]"
            >
              {{ user.name }}
              <!-- TODO Notification -->
              <!-- <sup><i class="mdi mdi-checkbox-blank-circle"></i></sup> -->
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="employeeBusinessUnits$ | async as businessUnits">
        <div
          *ngIf="businessUnits.length > 0"
          [routerLink]="[
            'user/my-bu',
            { requirementType: requirementType.ByDepartmentAdministrator, isMyBuSurveyTab: isMyBuSurveyTab }
          ]"
          routerLinkActive="active-navigation"
          (click)="isCollapsedMyBu = !isCollapsedMyBu"
          class="navigation-list mb-0"
          id="my-bu"
        >
          {{ 'lang.userMenu.myBU' | translate }}
        </div>
        <div [ngClass]="{ 'hide-menu': isCollapsedMyBu }">
          <div>
            <div
              *ngFor="let businessUnit of sortByDisplayName(businessUnits)"
              class="my-team"
              [routerLink]="[
                'user/my-bu',
                {
                  requirementType: requirementType.ByDepartmentAdministrator,
                  businessUnitId: businessUnit.id,
                  isMyBuSurveyTab: isMyBuSurveyTab
                }
              ]"
              (click)="activeBusinessUnitId = businessUnit.id"
              [ngClass]="{ 'active-navigation': activeBusinessUnitId == businessUnit.id }"
            >
              {{ businessUnit.displayName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="usermenu-footer col-2">
      <div class="font-weight-bold" [innerHTML]="getDesignedByFooter() | async"></div>
      <div class="footer-description" [innerHTML]="getFooter() | async"></div>
    </div>
  </div>
</aside>
